<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<!-- Feature #16: Pillar Page Generator dialog -->
<p-dialog header="Generate Pillar Page" [(visible)]="showPillarDialog" [modal]="true" [style]="{width:'560px'}" [closable]="true">
  <div class="mb-3">
    <label class="form-label">Topic Keyword *</label>
    <input pInputText class="form-control" [(ngModel)]="pillarKeyword" placeholder="e.g. Hawaii vacation rentals">
  </div>
  <div class="mb-3">
    <label class="form-label">Source Guides (select 3–8 published guides)</label>
    <div style="max-height:260px;overflow-y:auto;border:1px solid #dee2e6;border-radius:4px;">
      @for (g of publishedGuides; track g.contentId) {
        <div class="form-check px-3 py-1">
          <input class="form-check-input" type="checkbox" [id]="'pg_'+g.contentId"
            [value]="g.contentId"
            [checked]="pillarSelectedGuideIds.includes(g.contentId)"
            (change)="pillarSelectedGuideIds.includes(g.contentId) ? pillarSelectedGuideIds = pillarSelectedGuideIds.filter(id => id !== g.contentId) : pillarSelectedGuideIds = [...pillarSelectedGuideIds, g.contentId]">
          <label class="form-check-label" [for]="'pg_'+g.contentId">{{g.title}}</label>
        </div>
      }
    </div>
    <div class="text-muted small mt-1">{{pillarSelectedGuideIds.length}} selected</div>
  </div>
  <ng-template pTemplate="footer">
    <button pButton pRipple type="button" class="p-button-text" label="Cancel" (click)="showPillarDialog = false"></button>
    <button pButton pRipple type="button" class="p-button-primary" label="Generate"
      [disabled]="pillarLoading || !pillarKeyword || pillarSelectedGuideIds.length < 1"
      [loading]="pillarLoading"
      (click)="generatePillarPage()"></button>
  </ng-template>
</p-dialog>

<p-table #pt [value]="contents" [lazy]="true" (onLazyLoad)="loadLazy($event)" dataKey="contentId" selectionMode="multiple"
  [(selection)]="selectedContents" [loading]="loading" [paginator]="showPagination" [rows]="25"
  [rowsPerPageOptions]="[25,50,100]" showCurrentPageReport="true"
  currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}" [totalRecords]="recordTotal"
  sortMode="multiple" [multiSortMeta]="multiSortMeta" styleClass="p-datatable-striped" [ngStyle]="{'width': 'auto'}"
  [resizableColumns]="true" [autoLayout]="true" [responsive]="true">

  <ng-template pTemplate="caption">
    <div class="d-block text-end justify-content-between align-items-center">
      <h1 style="float: left;margin: 6px;">Content Management</h1>
      <span>
        @if (showFilter) {
          <button pButton pRipple class="p-button-text"
            style="font-size: 80%; padding: 0.643rem 0.75rem !important; margin-right:10px;"
            (click)="reloadPage()">Clear Filters</button>
        }
        <button pButton pRipple
          [ngClass]="reviewQueueActive ? 'p-button-warning' : 'p-button-outlined p-button-warning'"
          style="padding: 0.643rem 0.75rem !important; margin-right:10px;"
          (click)="toggleReviewQueue(pt)">Review Queue</button>
        <button pButton pRipple class="p-button-outlined p-button-secondary" style="padding: 0.643rem 0.75rem !important; margin-right:10px;"
          (click)="openPillarDialog()">Pillar Page</button>
        <button pButton pRipple class="p-button-outlined p-button-warning" style="padding: 0.643rem 0.75rem !important; margin-right:10px;"
          (click)="onGenerateContent()">AI Generate</button>
        <button pButton type="button" label="Regen Missing Meta" icon="pi pi-refresh"
          class="p-button-secondary p-button-sm" style="padding: 0.643rem 0.75rem !important; margin-right:10px;"
          (click)="regenMeta()"
          pTooltip="Fill null metaTitle/metaDescription via AI for all content rows"></button>
        <button pButton pRipple class="p-button" style="padding: 0.643rem 0.75rem !important;"
          (click)="onOpenFormAdd()">New Content +</button>
      </span>
    </div>
    @if (selectedContents?.length > 0) {
      <div class="d-flex align-items-center gap-2 mt-2 p-2" style="background:#f8f9fa;border-radius:4px;">
        <span class="fw-bold" style="white-space:nowrap;">{{ selectedContents.length }} selected</span>
        <select class="form-select form-select-sm" style="width:160px;" [(ngModel)]="bulkAction">
          <option value="">Set status...</option>
          @for (s of statuses; track s) {
            <option [value]="s.value">{{ s.name }}</option>
          }
        </select>
        <button pButton pRipple class="p-button-sm p-button-secondary" (click)="applyBulkAction()" [disabled]="!bulkAction">Apply</button>
        <button pButton pRipple class="p-button-sm p-button-text" (click)="selectedContents = []">Clear</button>
      </div>
    }
  </ng-template>

  <ng-template pTemplate="header">
    <tr>
      <th style="width:40px;"><p-tableHeaderCheckbox></p-tableHeaderCheckbox></th>
      @for (col of columns; track col) {
        <th [pSortableColumn]="col.field" [ngStyle]="{'width': col.width}">
          {{col.header}}
          <p-sortIcon [field]="col.field"></p-sortIcon>
        </th>
      }
      <th [ngStyle]="{'width': '60px'}"></th>
    </tr>
    @if (showFilter) {
      <tr>
        <th></th>
        <th><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'contentId', 'in')"></th>
        <th>
          <p-dropdown [options]="contentTypes" (onChange)="pt.filter($event.value, 'contentTypeId', 'in')" optionValue="contentTypeId" optionLabel="name"
            placeholder="All" [showClear]="true" [style]="{'min-width':'100%'}"></p-dropdown>
        </th>
        <th><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'title', 'in')"></th>
        <th>
          <p-dropdown [options]="statuses" (onChange)="pt.filter($event.value, 'status', 'in')" optionValue="value" optionLabel="name"
            placeholder="All" [showClear]="true" [style]="{'min-width':'100%'}"></p-dropdown>
        </th>
        <th></th>
        <th><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'locationId', 'in')"></th>
        <th>
          <p-multiSelect [options]="developments" optionLabel="displayName" optionValue="developmentId"
            (onChange)="pt.filter($event.value, 'developmentId', 'in')"
            defaultLabel="All" [showClear]="true" [style]="{'min-width':'100%'}" [maxSelectedLabels]="1"
            selectedItemsLabel="{0} selected">
          </p-multiSelect>
        </th>
        <th></th>
        <th></th>
        <th></th>
      </tr>
    }
  </ng-template>

  <ng-template pTemplate="body" let-content>
    <tr [pSelectableRow]="content" (dblclick)="onOpenFormEdit(content)">
      <td style="width:40px;"><p-tableCheckbox [value]="content"></p-tableCheckbox></td>
      <td>{{content.contentId}}</td>
      <td><span class="badge bg-primary">{{contentTypeName(content.contentTypeId)}}</span></td>
      <td>{{content.title}}</td>
      <td><span class="badge" [ngClass]="{'bg-secondary': content.status === 'DRAFT', 'bg-warning text-dark': content.status === 'REVIEW', 'bg-success': content.status === 'PUBLISHED', 'bg-dark': content.status === 'ARCHIVED'}">{{content.status}}</span></td>
      <td>{{content.viewCount | number}}</td>
      <td>{{content.locationId}}</td>
      <td style="font-size:85%">{{getDevelopmentName(content.developmentId)}}</td>
      <td>{{fixDates(content.publishDate)}}</td>
      <td>{{content.aiGenerated}}</td>
      <td>
        <span style="float:none">
          <a><i class="pi pi-pencil" aria-hidden="true" style="color:blue; font-size:110%; padding-right:10px;" (click)="onOpenFormEdit(content)"></i></a>
          <a><i class="pi pi-trash" aria-hidden="true" style="color:red; font-size:110%;" (click)="onRowDelete(content)"></i></a>
        </span>
      </td>
    </tr>
  </ng-template>

  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="10">No content found.</td>
    </tr>
  </ng-template>
</p-table>
